import React, { useState } from 'react';

const HelpIconTrigger = ({ onClick, serviceName = 'this service', className = '' }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        onClick={(e) => {
          e.stopPropagation(); // Prevent card click action
          onClick();
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`
          inline-flex items-center gap-2
          px-3 py-1.5
          rounded-full
          bg-white/20
          hover:bg-white/30
          backdrop-blur-sm
          border border-white/40
          text-white
          transition-all 
          duration-200
          hover:scale-105
          focus:outline-none 
          focus:ring-2 
          focus:ring-white/50
          focus:ring-offset-2
          ${className}
        `}
        aria-label={`Learn more about ${serviceName}`}
        type="button"
      >
        {/* DiAi Avatar */}
        <img 
          src="https://customer-assets.emergentagent.com/job_author-ai-beta/artifacts/lad4xvs5_DiAi_Image.jpg"
          alt="DiAi"
          className="w-6 h-6 rounded-full border border-white/50 shadow-sm"
        />
        {/* Need Help Text */}
        <span className="text-xs font-semibold whitespace-nowrap">
          Need Help?
        </span>
      </button>

      {/* Hover Tooltip */}
      {isHovered && (
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 z-10 animate-fade-in">
          <div className="bg-slate-900 text-white text-xs px-3 py-2 rounded-lg shadow-lg whitespace-nowrap">
            Learn more about {serviceName}
            {/* Arrow pointing up */}
            <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-slate-900 rotate-45"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HelpIconTrigger;
